import { defineComponent as k, useSlots as v, useCssModule as L, computed as p, openBlock as n, createElementBlock as o, normalizeClass as s, unref as e, createElementVNode as i, createTextVNode as $, toDisplayString as h, createCommentVNode as r, renderSlot as d } from "vue";
import m from "../../utils/mapClasses.mjs";
const g = ["for"], B = {
  key: 0,
  "aria-hidden": "true"
}, I = {
  key: 0
}, q = ["id"], N = "cdr-label-standalone", z = /* @__PURE__ */ k({
  name: "CdrLabelStandalone",
  __name: "CdrLabelStandalone",
  props: {
    forId: {
      type: String,
      required: !0
    },
    label: String,
    disabled: Boolean,
    required: Boolean,
    optional: Boolean,
    hideLabel: Boolean,
    labelClass: {
      type: String,
      default: ""
    }
  },
  setup(l) {
    const c = l, b = v(), a = L(), u = b.helper, f = b.info, C = b["info-action"], y = p(() => c.disabled ? "cdr-label-standalone__label--disabled" : ""), _ = p(() => c.hideLabel ? "cdr-label-standalone__label--sr-only" : ""), S = p(() => !c.hideLabel || u || f ? "cdr-label-standalone__input-spacing" : "");
    return (t, V) => (n(), o("div", {
      class: s(e(a)[N])
    }, [i("div", {
      class: s(e(a)["cdr-label-standalone__label-wrapper"])
    }, [i("label", {
      class: s(e(m)(e(a), "cdr-label-standalone__label", y.value, _.value).concat(` ${l.labelClass}`)),
      for: l.forId
    }, [$(h(l.label) + h((l.required || l.optional, "")) + " ", 1), l.required ? (n(), o("span", B, "*")) : l.optional ? (n(), o("span", {
      key: 1,
      class: s(e(a)["cdr-label-standalone__optional"])
    }, "(optional)", 2)) : r("", !0)], 10, g), !l.hideLabel && e(u) ? (n(), o("br", I)) : r("", !0), e(u) ? (n(), o("span", {
      key: 1,
      class: s(e(a)["cdr-label-standalone__helper"]),
      id: `${l.forId}-helper-text-top`
    }, [d(t.$slots, "helper")], 10, q)) : r("", !0)], 2), i("div", {
      class: s(e(m)(e(a), "cdr-label-standalone__input-wrap", S.value))
    }, [d(t.$slots, "default"), e(C) ? (n(), o("div", {
      key: 0,
      class: s(e(a)["cdr-label-standalone__info-action"])
    }, [d(t.$slots, "info-action")], 2)) : r("", !0)], 2), e(f) ? (n(), o("span", {
      key: 0,
      class: s(e(a)["cdr-label-standalone__info"])
    }, [d(t.$slots, "info")], 2)) : r("", !0), i("div", {
      class: s(e(a)["cdr-label-standalone__post-content"])
    }, [d(t.$slots, "helper-text-bottom"), d(t.$slots, "error")], 2)], 2));
  }
});
export {
  z as default
};
